module.exports = __webpack_public_path__ + "static/media/associates-icon.a9719de2.svg";